import React from 'react';
import { Button, Icon, Switch, FormGroup, FormControl } from 'components';
import styles from 'styles/campaign_settings_second_step.module.scss';
import ExtraModules from './ExtraModules/index';
import GeoTargeting from './GeoTargeting'
import { AddToUnlock, Bundles, OneCheckUpSell } from './Types';

const SecondStep = ({
	context,
	setActiveTab,
	stickyHeaderPosition: headerPosition,
	stickyHeader,
	setShowATUAfterText,
	shopContext
}) => {
	const { state: campaign, setItem, validationErrors } = context;

	return (
		<>
			{campaign.settings.type === 'bundles' && <Bundles {...{ context, shopContext, validationErrors }} />}
			{campaign.settings.type === 'add_to_unlock' && (
				<AddToUnlock {...{ context, validationErrors, setShowATUAfterText }} />
			)}
			{campaign.settings.type === 'one_check_up_sell' && <OneCheckUpSell {...{ context, validationErrors }} />}
			<GeoTargeting context={context} />
			<ExtraModules context={context} hasCheckout={false} />
		</>
	);
};

export default SecondStep;
